import { authApi } from 'shared/api/auth'
import { createPusherSocket } from 'shared/services/socket'

const authSocket = createPusherSocket({
  socketName: 'auth',
  appKey: process.env.REACT_APP_AUTH_PUSHER_APP_KEY,
  wsHost: process.env.REACT_APP_WS_HOST,
  wsPort: Number(process.env.REACT_APP_WS_PORT ?? 443),
  channelAuthorization: {
    endpoint: `${process.env.REACT_APP_AUTH_ENDPOINT}broadcasting/auth`,
    transport: 'ajax',
    // authApi attaches a fresh token on every call and refreshes
    // it on 401, so re-authorizations after a reconnect keep working
    // even after the token has rotated.
    customHandler: ({ socketId, channelName }, callback) => {
      authApi
        .post('broadcasting/auth', {
          socket_id: socketId,
          channel_name: channelName
        })
        .then(({ data }) => callback(null, data))
        .catch(error => callback(error as Error, null))
    }
  }
})

export const subscribeToAuthChannel = authSocket.subscribe
